module.exports = __webpack_public_path__ + "static/img/Nature.54c0c86.png";